import { Component, OnInit, inject } from '@angular/core';
import { Audit, ParsedAudit } from '../../../core/models/audit.model';
import { NavigationService } from 'app/core/services/navigation.service';
import { AuditsService } from 'app/core/services/audits.service';
import { DatePipe } from '@angular/common';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';
import { UsersService } from 'app/core/services/users.service';
import { User } from 'app/core/models/user.model';
import { createParsedAudit } from 'app/core/lib/audit-utils';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-user-audit',
    templateUrl: './capture-admin-user-audit.component.html',
    styleUrls: ['./capture-admin-user-audit.component.scss'],
    imports: [PaginationHeaderComponent, PaginationComponent, MatProgressSpinner, DatePipe]
})
export class CaptureAdminUserAuditComponent implements OnInit {
  private auditsService = inject(AuditsService);
  private navigationService = inject(NavigationService);
  private userService = inject(UsersService);
  private datePipe = inject(DatePipe);

  userId = parseInt(this.navigationService.currentId, 10);
  user: User;
  paging: LimitOffsetPaging;
  loading = true;
  parsedAudits: ParsedAudit[];
  audits: Audit[];
  notSetString = 'not set';

  modelNameStrings = {
    User: 'User',
    UserRole: 'User Role',
    UserAssignedClient: 'User Assigned Client',
  };

  ngOnInit() {
    this.paging = LimitOffsetPaging.empty;
    this.paging.currentPage = 1;
    this.loadUser();
    this.loadAudits(this.paging.currentPage);
  }

  onPageSizeChange(size: number) {
    this.paging.pageSize = size;
    this.loadAudits(this.paging.currentPage);
  }

  onPageChange(page: number) {
    this.loadAudits(page);
  }

  private loadUser() {
    this.userService.get(this.userId).subscribe(u => this.user = u)
  }

  private loadAudits(page: number) {
    const paging = { page, pageSize: this.paging.pageSize };

    this.loading = true;
    this.auditsService.getList(paging, 'User', [this.userId], true).subscribe(response => {
      this.paging = response.meta.paging;
      this.parsedAudits = response.audits.map(audit => this.auditToParseAudit(audit));
      this.loading = false;
    });
  }

  private auditToParseAudit(audit: Audit): ParsedAudit | null {
    const {
      id, // eslint-disable-line unused-imports/no-unused-vars
      ...changes
    } = audit.auditedChanges;

    return createParsedAudit(audit, changes, this.notSetString);
  }
}
